import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from 'lodash.flowright';

import { mapProps } from '../../../../../../../../../../../util/hocs';
import DesignEditor from '../../../../../../../../../../../components/global/DesignEditor';
import DesignEditorHeader, {
  DesignEditorHeaderCenterSlot,
  DesignEditorHeaderLeftSlot,
  DesignEditorHeaderRightSlot,
} from '../../../../../../../../../../../components/global/DesignEditor/components/DesignEditorHeader';
import DesignEditorPreviewPane from '../../../../../../../../../../../components/global/DesignEditor/components/DesignEditorPreviewPane';
import Button from '../../../../../../../../../../../components/global/Button';
import withModal from '../../../../../../../../../../../components/global/modal/withModal';
import AccountCard from '../../../../../../../../../../../services/cards/components/AccountCard';
import { getCardTemplateSizing } from '../../../../../../../../../../../services/cards/components/AccountCard/helpers';
import { CARD_SIDE } from '../../../../../../../../../../../services/cards/constants';

export const PRINT_PACKAGE_DIGITAL_DOWNLOAD_ACCOUNT_CARD_MODAL =
  'modal/PRINT_PACKAGE_DIGITAL_DOWNLOAD_ACCOUNT_CARD';

const propTypes = {
  selectedAccountCard: PropTypes.shape({
    id: PropTypes.string,
  }),
  accountCards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  onAccountCardSelected: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const PrintPackageDigitalDownloadAccountCardModal = ({
  selectedAccountCard: currentSelectedAccountCard,
  accountCards = [],
  onAccountCardSelected,
  className,
}) => {
  const [selectedAccountCard, setSelectedAccountCard] = useState(
    currentSelectedAccountCard,
  );

  const classes = classNames({
    [className]: !!className,
    'print-package-digital-download-account-card-editor': true,
  });

  return (
    <DesignEditor className={classes}>
      <DesignEditorHeader>
        <DesignEditorHeaderLeftSlot />
        <DesignEditorHeaderCenterSlot>
          <h3 className="my-1 text-center">Configure your package</h3>
        </DesignEditorHeaderCenterSlot>
        <DesignEditorHeaderRightSlot />
      </DesignEditorHeader>

      <DesignEditorPreviewPane className="print-package-digital-download-account-card-preview-pane">
        <h4 className="my-1 text-center">
          Select your preferred pose for digital download
        </h4>
        <div className="print-package-digital-download-account-card-grid">
          {accountCards.map(accountCard => {
            const isSelected = selectedAccountCard?.id === accountCard.id;
            const cardSide = accountCard.account_card_sides.find(
              accountCardSide => accountCardSide.side === CARD_SIDE.FRONT,
            )?.card_side;
            const cardClasses = classNames({
              'print-package-digital-download-account-card-grid-card': true,
              'is-selected': isSelected,
            });

            const { ratio } = getCardTemplateSizing(cardSide?.card_template);

            return (
              <div
                role="button"
                tabIndex={0}
                className={cardClasses}
                onClick={() => setSelectedAccountCard(accountCard)}
                style={{
                  padding: `0 ${ratio * 20}%`,
                }}
              >
                <AccountCard
                  onElementConfigurationChange={() => {}}
                  accountCard={accountCard}
                  animatable={false}
                  viewOnly
                  disablePhotoWatermarkOverlay
                />
              </div>
            );
          })}
        </div>

        <div className="print-package-digital-download-account-card-continue-wrap">
          <Button
            disabled={!selectedAccountCard}
            className="print-package-digital-download-account-card-continue"
            onClick={() => {
              onAccountCardSelected(selectedAccountCard);
            }}
          >
            Confirm &amp; continue
          </Button>
        </div>
      </DesignEditorPreviewPane>
    </DesignEditor>
  );
};

PrintPackageDigitalDownloadAccountCardModal.propTypes = propTypes;

export default withModal(
  compose(
    mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
      onClose: onRequestClose,
      ...actionProps,
      ...props,
    })),
  )(PrintPackageDigitalDownloadAccountCardModal),
  {
    name: PRINT_PACKAGE_DIGITAL_DOWNLOAD_ACCOUNT_CARD_MODAL,
    dismissible: false,
    type: 'full',
    hideHeader: true,
    className: 'print-package-digital-download-account-card-modal',
  },
);
